import * as React from "react";
const SvgBurger = props => <svg xmlns="http://www.w3.org/2000/svg" width={22} height={20} fill="none" viewBox="0 0 22 20" {...props}><path fill="currentColor" d="M1 3h20v2H1zm0 6h20v2H1zm0 6h20v2H1z" /></svg>;
export default SvgBurger;